import React from "react";
import Column from "@amzn/meridian/column";
import Heading from "@amzn/meridian/heading";
import Text from "@amzn/meridian/text";

const VlmAuditWorkflow = () => {
  return (
    <Column spacingInset={"500"} spacing={"300"}>
      <Heading level={2}>VLM Audit Workflow</Heading>
      <Text>This page is under construction. Check back soon.</Text>
    </Column>
  );
};

export default VlmAuditWorkflow;
